export default __webpack_public_path__ + "static/media/emptyAccont.caf0ef88.png";